import React, { useRef, useLayoutEffect, useEffect } from "react";
import { EuiTextArea } from "@elastic/eui";

function AutoGrowEuiTextArea({
  value,
  onChange,
  maxRows,
  isPlusAllowed,
  ...rest
}: {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  maxRows?: number;
  isPlusAllowed?: boolean;
}) {
  const taRef = useRef<HTMLTextAreaElement | null>(null);

  const resize = () => {
    const el = taRef.current;
    if (!el) return;
    el.style.height = "auto";

    const style = window.getComputedStyle(el);
    const paddingTop = parseFloat(style.paddingTop || "0");
    const paddingBottom = parseFloat(style.paddingBottom || "0");
    const rawLineHeight = style.lineHeight;
    let lineHeight = parseFloat(rawLineHeight || "0");
    if (!lineHeight || Number.isNaN(lineHeight)) {
      const fontSize = parseFloat(style.fontSize || "16");
      lineHeight = fontSize * 1.2;
    }

    const scrollHeight = el.scrollHeight;
    if (maxRows) {
      const maxHeight = lineHeight * maxRows + paddingTop + paddingBottom;
      if (scrollHeight > maxHeight) {
        el.style.height = `${maxHeight}px`;
        el.style.overflowY = "auto";
      } else {
        el.style.height = `${scrollHeight}px`;
        el.style.overflowY = "hidden";
      }
    } else {
      el.style.height = `${scrollHeight}px`;
      el.style.overflowY = "hidden";
    }
  };

  useLayoutEffect(() => {
    resize();
  }, [value, maxRows]);

  useEffect(() => {
    const handler = () => resize();
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter") {
      e.preventDefault(); // stop newline insertion
    }
  };

  return (
    <EuiTextArea
      inputRef={taRef}
      rows={1}
      value={value}
      onChange={(e) => {
        onChange(e);
      }}
      className="advisor_text_area"
      onKeyDown={handleKeyDown}
      onInput={resize}
      style={{
        backgroundColor: "var(--card-background)",
        overflow: "hidden",
        minHeight: "45px",
        borderRadius: "25px 25px 25px 25px",
        paddingRight: "16px",
        paddingBottom: value?.length > 70 ? "45px" : "0px",
        paddingLeft: value?.length > 70 ? "16px" : isPlusAllowed ? "45px" : "16px",
        resize: "none",
      }}
      {...rest}
      fullWidth
    />
  );
}

export default AutoGrowEuiTextArea;
